import { Typography, Box } from "@material-ui/core";
import React, { useState } from "react";
import { formatUnixToDateString } from "../functions/sensorFunctions";
import styles from "./comment.module.scss";
import { EditButton } from "common/components/EditButton";
import DeleteIcon from "common/icons/DeleteIcon";
import EditIcon from "common/icons/EditIcon";
import { t } from "i18next";
import { useParams } from "react-router";
import { deleteComment } from "safetySensors/Sensors.actions";
import { useDispatch, useSelector } from "react-redux";
import { ConfirmOrCancelDialog } from "Profile/components/ConfirmOrCancelDialog";
import { IApplicationState } from "redux/root-reducer";
import { NewComment } from "comments/components/newComment";

interface IComment {
  commentID: number;
}

export const Comment = ({ commentID }: IComment) => {
  const { sensorComments } =
    useSelector((store: IApplicationState) => store.sensors) || {};
  const currentComment = sensorComments.find(
    (comment) => comment.ID === commentID
  );
  if (!currentComment) return null;
  const dispatch = useDispatch();
  const convertedDate = formatUnixToDateString(currentComment.Created);
  const domain = useSelector(
    (state: IApplicationState) => state.common.selectedDomain
  );
  const { sensorId }: { sensorId: string } = useParams();
  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);
  const [openEditDialog, setOpenEditDialog] = useState<boolean>(false);

  const handleDelete = () => {
    setOpenDeleteDialog(false);
    dispatch(deleteComment(domain!.Code, commentID));
  };
  return (
    <div className={styles.container}>
      <Typography variant="h4">{convertedDate}</Typography>
      <Typography variant="h4">
        <span>{t("Written by: ")} </span>
        {currentComment.CreatedBy}
      </Typography>
      <Typography variant="body2">{currentComment.Text}</Typography>
      <Box display={"flex"} style={{ gap: 15 }} alignSelf={"flex-end"}>
        <Box onClick={() => setOpenEditDialog(true)}>
          <EditButton title={t("Edit")} icon={<EditIcon height={20} />} />
        </Box>
        <Box onClick={() => setOpenDeleteDialog(true)}>
          <EditButton
            title={t("Remove")}
            icon={<DeleteIcon height={20} />}
            iconColor="var(--color-red)"
          />
        </Box>
        <ConfirmOrCancelDialog
          open={openDeleteDialog}
          onClose={() => setOpenDeleteDialog(false)}
          onConfirm={handleDelete}
          text={t("Are you sure you want to delete the comment?")}
          confirmIsDelete={true}
        />
        <NewComment
          open={openEditDialog}
          onClose={() => setOpenEditDialog(false)}
          comment={currentComment}
          measuringPointId={parseInt(sensorId)}
        />
      </Box>
    </div>
  );
};
